import { MenuItem, Select } from '@mui/material';
import { allClassNumbers } from '../helpers/academic-years';

interface ClassSelectProps {
  onChange: (updatedClass: number) => void;
  defaultValue?: number;
  fullWidth?: boolean;
  outlined?: boolean;
}

const ClassSelect: React.FC<ClassSelectProps> = ({
  onChange,
  defaultValue,
  fullWidth = false,
  outlined = false,
}) => (
  <Select
    required
    variant={outlined ? 'outlined' : 'standard'}
    size={outlined ? 'small' : 'medium'}
    fullWidth={fullWidth}
    onChange={(event) => onChange(event.target.value as number)}
    value={defaultValue ?? 1}
  >
    {allClassNumbers.map((classNumber) => (
      <MenuItem key={classNumber} value={classNumber}>
        {`${classNumber}. třída`}
      </MenuItem>
    ))}
  </Select>
);

export default ClassSelect;
